import { EventEmitter, Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { environment } from "../../environments/environment";
import { buildAetUserContext } from '../core/constant/user-context.util';
@Injectable({
	providedIn: 'root'
})
export class EventService {

	baseURL = environment.baseAPIURL;
    caDetails:EventEmitter<any> = new EventEmitter<any>();
	public site:any;
	constructor( private readonly http  : HttpClient) { }

	getEventDetails(data, upn, roles, lpCodes) {  
		const userReqDto = this.buildEventUserReqDto(upn, roles, lpCodes);
		const rb = {
			event: {
				eventId: data?.eventId,
				pageNo: data?.pageNo,
				pageSize: data?.pageSize,
			},
			userReqDto,
		};

		return this.http.post(`${this.baseURL}/aetHistory/setupEventDetails/${data.eventId}/${data.pageNo}/${data.pageSize}`, rb, { responseType: 'json' })
			.pipe(catchError(this.handleError));
	}

	getEvents(data) {
		return this.http.get(`${this.baseURL}/aetHistory/getEventOrdersInfo/${data.eventId}/${data.pageNo}/${data.pageSize}/asc/1`, { responseType: 'json' })
			.pipe(catchError(this.handleError));
	}

	private buildEventUserReqDto(upn: any, roles: any, lpCodes: any) {
		const base = buildAetUserContext();
		const normalizedRoles = Array.isArray(roles)
			? roles
			: typeof roles === 'string'
				? roles.split(',').map((role) => role.trim()).filter((role) => !!role)
				: base.roles;
		const normalizedLpCodes = Array.isArray(lpCodes)
			? lpCodes.filter((code) => !!code).join(',')
			: typeof lpCodes === 'string'
				? lpCodes
				: base.additionalLpCode;

		return {
			...base,
			userPrincipalName: upn ?? base.userPrincipalName,
			email: upn ?? base.email,
			roles: normalizedRoles,
			additionalLpCode: normalizedLpCodes,
		};
	}
	
	private handleError(error: HttpErrorResponse) {
		return throwError(error.message || "Server Error");
	}
}

